<template>
    <div class="announcement-details-vue">
        <div
            v-if="content.image?.source_url"
            class="announcement-banner"
        >
            <img
                :src="content.image.source_url"
                alt="Announcement banner"
            />
        </div>

        <div class="announcement-body">
            <div class="announcement-date">
                {{ formattedCreatedAt }}
            </div>

            <div class="announcement-title">
                {{ content.title }}
            </div>

            <div
                class="announcement-content"
                v-html="content.content"
            ></div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import httpMixin from "@/v2/mixins/http.js";
import { returnPopupMixin } from "@/v2/mixins/bo-return-popup.js";

export default {
    mixins: [returnPopupMixin, httpMixin],

    props: {
        title: {
            type: String,
            default: "",
        },
        content: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            generalTranslations: window.bo.generalTranslations,
            contentDetailsUrl: window.bo.contentDetailsUrl,
            searchValue: "",
            pageNumber: "",
        };
    },

    mounted() {
        window.addEventListener("scroll", this.handleScroll);
    },

    computed: {
        formattedCreatedAt() {
            if (!this.content?.created_at) return '';

            const date = new Date(this.content.created_at);

            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();

            let hours = date.getHours();
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const ampm = hours >= 12 ? 'pm' : 'am';
            let translatedAmpm = this.generalTranslations[ampm] ?? ampm;
            hours = hours % 12 || 12;

            return `${day}/${month}/${year}, ${hours}:${minutes}${translatedAmpm}`;
        }
    },

    watch: {},

    methods: {
    },
};
</script>
